<template>
    <div class="navigationBar relative h-full w-[75px] flex flex-col">

    <div class="navigationBarExpander fixed h-full bg-card-primary shadow-md rounded-r-md" :class="{navigationClosed:isNavOpen}">
        <div class="gridMenu overflow-hidden ">
            <div class="p-2 w-full w-[300px]">
                <!-- <UVerticalNavigation :links="links" />  -->
                <div class="flex flex-col gap-1 pt-1">
                    <UButton
                        v-for="icon in iconLinks"
                        :icon="icon.icon"
                        size="lg"
                        :color="icon.color?icon.color:'primary'"
                        variant="link"
                        :label="icon.label"
                        :trailing="false"
                    />
                </div>  
            </div>
        </div>

        <div class="gridLine bg-green-400 h-[90%] w-[1px]">
        </div>
        
        <div class="gridMenuIcons items-center p-2">
            
            <div class="flex flex-col items-center justify-center">

                    <UButton
                        class="mb-5"
                        @click="toggleNavigation"
                        :icon="isNavOpen?'i-heroicons-bars-3':'i-heroicons-x-mark'"
                        size="lg"
                        color="primary"
                        square
                        variant="solid"
                    />
                    <div class="flex flex-col gap-1 pt-1 items-center">

                        <UTooltip v-for="icon in iconLinks" :key="icon.to" 
                        :text="icon.toolTip" 
                        :shortcuts="[]" 
                        :content="{ side: 'right' }"
                        >
                        <UButton
                        :icon="icon.icon"
                        :size="navIconSize"
                        :color="icon.color?icon.color:'primary'"
                        square
                        variant="link"
                        :ui="navIconUiSize"
                        />
                        </UTooltip>

                    </div>

        
            </div>
        </div>
    </div>

    </div>
</template>

<script setup>

/* Open/Close logic for the navigation bar */
const isNavOpen = useState('isNavOpen', () => true);
const toggleNavigation = () => {
    isNavOpen.value = !isNavOpen.value;
}

/* Links for the navigation */
const links = [
[{
  label: 'This is a nuxt link',
  icon: 'i-heroicons-home',
  to: '/dashboard'
}, {
  label: 'This is a nuxt link',
  icon: 'i-heroicons-chart-bar',
  to: '/dashboard'
}, {
  label: 'This is a nuxt link',
  icon: 'i-heroicons-command-line',
  to: '/dashboard'
}],
[{
  label: 'This is a nuxt link',
  icon: 'i-heroicons-home',
  to: '/dashboard'
}, {
  label: 'This is a nuxt link',
  icon: 'i-heroicons-chart-bar',
  to: '/dashboard'
}, {
  label: 'This is a nuxt link',
  icon: 'i-heroicons-command-line',
  to: '/dashboard'
}],
]

const iconLinks = [
{
  label: 'Installation',
  icon: 'i-heroicons-home',
  to: '/dashboard',
  color: 'primary',
  toolTip: 'Installation'
}, {
  label: 'Vertical-navigation',
  icon: 'i-heroicons-pencil-square',
  to: '/dashboard',
  color: 'warning',
  toolTip: 'Vertical-navigation'
}, {
  label: 'Command-palette',
  icon: 'i-heroicons-chart-bar',
  to: '/dashboard',
  color: 'info',
  toolTip: 'Command-palette'
}]

/* Icon size logic */
const navIconSize = useState('navIconSize',() => 'xl');
const navIconUiSize = useState('navIconUiSize',() => {
    return {
        'icon':{
            'size':{
                'xl': 'h-8 w-8'
            }
        }
    }
});

</script>

<style lang="scss">
.navigationBar{

.navigationBarExpander{
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-template-rows: 1fr;
    grid-template-areas:
    "menu line icons";
    transition:all .3s ease;
}

.gridMenu{
    grid-area: menu;
}
.gridMenuIcons{
    grid-area: icons;
}
.gridLine{
    grid-area: line;
    align-self: center;
}
}

.navigationClosed{
    grid-template-columns: 0fr auto 75px!important;
    overflow: hidden;
}
</style>